const STORAGE_KEY = 'questionHistory';

class QuestionHistory {
  constructor(maxSize = 50) {
    this.maxSize = maxSize;
    this.currentIndex = -1;
    this.tempInput = ""; // Stores current input when navigating
    // Load history from localStorage
    this.history = this.loadFromStorage();
  }

  loadFromStorage() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        return Array.isArray(parsed) ? parsed : [];
      }
    } catch (e) {
      console.warn('Failed to load question history from localStorage:', e);
    }
    return [];
  }

  saveToStorage() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.history));
    } catch (e) {
      console.warn('Failed to save question history to localStorage:', e);
    }
  }

  add(question) {
    // Don't add empty questions or duplicates of the last question
    if (
      !question.trim() ||
      (this.history.length > 0 && this.history[0] === question)
    ) {
      return;
    }

    this.history.unshift(question);
    if (this.history.length > this.maxSize) {
      this.history.pop();
    }
    this.currentIndex = -1;
    this.tempInput = "";
    // Persist to localStorage
    this.saveToStorage();
  }

  up(currentInput) {
    // Save current input when starting navigation
    if (this.currentIndex === -1) {
      this.tempInput = currentInput;
    }

    if (this.currentIndex < this.history.length - 1) {
      this.currentIndex++;
      return this.history[this.currentIndex];
    }
    return this.history[this.currentIndex] || "";
  }

  down() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      return this.history[this.currentIndex];
    } else if (this.currentIndex === 0) {
      this.currentIndex = -1;
      return this.tempInput;
    }
    return "";
  }

  reset() {
    this.currentIndex = -1;
    this.tempInput = "";
  }
}

export default QuestionHistory;
